import { render, staticRenderFns } from "./OtpView.vue?vue&type=template&id=62a7e13b&scoped=true"
import script from "./OtpView.vue?vue&type=script&lang=js"
export * from "./OtpView.vue?vue&type=script&lang=js"
import style0 from "./OtpView.vue?vue&type=style&index=0&id=62a7e13b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a7e13b",
  null
  
)

export default component.exports